const { viewportSize, getElement } = window.BAO.Utils
class QuickView extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleResize = this.handleResize.bind(this)

    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
    this.externalEls.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.listeners.add(window, 'cart:updated', this.handleClose)
    this.listeners.add(window, 'resize', this.handleResize)
  }

  async handleTrigger() {
    const url = `/products/${this.dataset.handle}?section_id=quick-view`

    try {
      await this.fromFetch('quick-view', url) // Await the completion of fromFetch
      .then(() => {
        this.setAttribute('data-modal-open', 'true')
        document.body.classList.toggle('util-SiteOverflowed', true)
        this.externalEls.modal.element.setAttribute('aria-hidden', 'false')
        this.open = true
      })
      .then(() => {
        window.dispatchEvent(new Event('resize'))
      })
      .catch(error => {
        console.error('Rendering failed:', error)
      })
    } catch (error) {
      console.error('Fetching failed:', error)
    }
  }


  handleClose () {
    this.externalEls.modal.element.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
    this.open = false
  }

  handleResize () {
    if (!this.open) return
    const vs = viewportSize()

    if (vs === `xs` || vs === 'sm') {
      this.handleClose()
    }
  }

  /**
   * @param {String} section
   * @param {String} url
   * @param {SubmitEvent} e
   *
   * @returns {void}
   */
  async fromFetch (section, url, e) {
    const html = await window.BAO.sectionRenderer.fetchSingle(section, url)

    this.render(html, e)
  }

  /**
   * @param {String} html
   * @param {SubmitEvent} e
   *
   * @returns {void}
   */
/**
 * @param {String} html
 * @param {SubmitEvent} e
 *
 * @returns {Promise<void>}
 */
render(html, e) {
  return new Promise((resolve, reject) => {
    try {
      this.externalEls.container.element.innerHTML = html
      window.dispatchEvent(new Event('resize'))

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
        resolve()
      }, 400)
    } catch (error) {
      reject(error)
    }
  })
}
}

if (!customElements.get('quick-view')) {
  customElements.define('quick-view', QuickView)
}
